// extracted by mini-css-extract-plugin
export default {"hidden":"Embaixador_hidden__dwIwi","loading":"Embaixador_loading__8L3O0","content":"Embaixador_content__vnTtv","section_button":"Embaixador_section_button__tn6wn"};